import StocksConfigurationProduitsNiveauxController from './stocks.configuration.produits.niveaux.controller';
import Template from './stocks.configuration.produits.niveaux.html';

export default {
	controller: StocksConfigurationProduitsNiveauxController,
	template: Template
};
